"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _useToggler2 = _interopRequireDefault(require("../../hooks/useToggler"));

var _excluded = ["isAlertOpen", "confirmButtonLabel", "cancelButtonLabel", "color", "onOpen", "onConfirm", "onCancel", "onClose", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The Alert component is used to display some information to the user in a <strong>non-obtrusive</strong> way.
 * An Alert is meant to stay visible to the user until he interacts with it.
 *
 * If you want a way to prevent the user to interact with the page before taking action, use a Modal component instead.
 * If you don't want to force the user to interact with it, use a Toast component instead.
 */
var Alert = function Alert(_ref) {
  var controlledIsOpen = _ref.isAlertOpen,
      confirmButtonLabel = _ref.confirmButtonLabel,
      cancelButtonLabel = _ref.cancelButtonLabel,
      color = _ref.color,
      onOpen = _ref.onOpen,
      onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel,
      onClose = _ref.onClose,
      className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useToggler = (0, _useToggler2.default)(controlledIsOpen || false),
      isOpen = _useToggler.isOpen,
      setOpen = _useToggler.setOpen,
      setClose = _useToggler.setClose;

  _react.default.useEffect(function () {
    if (controlledIsOpen) {
      setOpen();
    } else {
      setClose();
    }
  }, [controlledIsOpen, setClose, setOpen]);

  var handleAlertConfirm = function handleAlertConfirm() {
    setClose();

    if (typeof onConfirm === 'function') {
      onConfirm();
    }
  };

  var handleAlertCancel = function handleAlertCancel() {
    setClose();

    if (typeof onCancel === 'function') {
      onCancel();
    }
  };

  var classes = (0, _clsx.default)('uk-alert', !isOpen && 'uk-alert--hidden', "uk-color--white uk-bgcolor--" + color, className);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classes
  }, attributes, {
    role: "alert"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-alert__message"
  }, children), (cancelButtonLabel || confirmButtonLabel) && /*#__PURE__*/_react.default.createElement("div", {
    className: "grid-x grid-margin-x"
  }, cancelButtonLabel && /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: handleAlertCancel,
    size: "small",
    color: "white",
    outline: true,
    label: cancelButtonLabel,
    className: "cell shrink"
  }), confirmButtonLabel && /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: handleAlertConfirm,
    size: "small",
    color: "white",
    label: confirmButtonLabel,
    className: "cell shrink"
  })));
};

Alert.propTypes = {
  /**
   * Show or hide the Alert
   */
  isAlertOpen: _propTypes.default.bool,

  /**
   * Label of the confirm Button
   */
  confirmButtonLabel: _propTypes.default.string,

  /**
   * Label of the cancel Button
   */
  cancelButtonLabel: _propTypes.default.string,

  /**
   * Background-color of the Alert
   */
  color: _propTypes.default.oneOf(['success', 'alert', 'warning']),

  /**
   * Callback function onOpen
   * Invoked when the Alert opens
   */
  onOpen: _propTypes.default.func,

  /**
   * Callback function onConfirm
   * Invoked on click of the confirm Button
   */
  onConfirm: _propTypes.default.func,

  /**
   * Callback function onCancel
   * Invoked on click of the cancel Button
   */
  onCancel: _propTypes.default.func,

  /**
   * Callback function onClose
   * Invoked when the Alert closes
   */
  onClose: _propTypes.default.func
};
Alert.defaultProps = {
  isAlertOpen: false,
  color: 'success'
};
var _default = Alert;
exports.default = _default;